import { useState } from "react";

export interface FaqItem {
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="space-y-2">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={item.question}
            className="rounded-lg border border-background-200/80 bg-background-50 overflow-hidden transition-colors duration-200"
          >
            <h3 className="m-0">
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-3 md:gap-4 text-left px-3.5 md:px-5 py-3 md:py-4 cursor-pointer"
              >
                <span className="text-[13px] md:text-base font-heading font-semibold text-primary-900 leading-snug">
                  {item.question}
                </span>
                <span
                  className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
                    isOpen ? "bg-accent-500 text-primary-950" : "bg-primary-100 text-primary-700"
                  }`}
                >
                  <i className={`text-base ${isOpen ? "ri-subtract-line" : "ri-add-line"}`} />
                </span>
              </button>
            </h3>
            <div
              className={`grid transition-all duration-300 ease-in-out ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-3.5 md:px-5 pb-3.5 md:pb-4 text-[11px] md:text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}